<template>
  <div>
    <data-grid
      url="users"
      :columns="columns"
      :title="title"
      :actions="actions"
      :onRowClicked="onRowClicked"
      ref="grid"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
    ></data-grid>
    <v-dialog v-model="deleteUserConfirmationDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-title class="headline text-danger">Are You Sure?</v-card-title>
        <v-card-text
          >This will delete User:
          <div class="font-weight-medium">
            {{ userClicked.userName }}
          </div></v-card-text
        >
        <v-card-actions>
          <div class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn
              color="default"
              dark
              @click="deleteUserConfirmationDialog = false"
              >Cancel</v-btn
            >
            <v-btn color="success" :loading="deletingUser" @click="deleteUser"
              >Delete</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="updateUserDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-title class="headline">User</v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-layout row class="mb-2">
            <div class="font-weight-medium mr-2">
              User Name:
            </div>
            <div>
              {{ userClicked.userName }}
            </div>
            <v-spacer></v-spacer>
            <v-btn
              @click="resetPassword()"
              v-if="!showResetPasswordSection && !userClicked.isWindowsUser"
              class="mt-0"
              color="success"
              small
              outline
              >Reset Password</v-btn
            >
            <v-btn
              @click="showResetPasswordSection = false"
              v-if="showResetPasswordSection"
              class="mt-0"
              color="success"
              small
              outline
              >Cancel Reset Password</v-btn
            >
            <v-btn
              @click="openLoginHistory()"
              class="mt-0 ml-2"
              color="primary"
              small
              outline
              >Login History</v-btn
            >
          </v-layout>
        </v-card-text>

        <v-text-field
          v-if="showResetPasswordSection"
          class="mx-3"
          label="New Password"
          v-model="newPassword"
          ref="newPassword"
          type="password"
          :rules="[rules.required]"
        ></v-text-field>

        <v-text-field
          class="mx-3"
          label="Name"
          v-model="userClicked.name"
          ref="name"
        ></v-text-field>
        <v-text-field
          class="mx-3"
          label="Email"
          v-model="userClicked.email"
          ref="email"
          :rules="[rules.email]"
        ></v-text-field>
        <v-text-field
          class="mx-3"
          label="Phone Number"
          v-model="userClicked.phoneNumber"
          ref="phoneNumber"
          :rules="[rules.phone]"
        ></v-text-field>
        <v-text-field
          class="mx-3 mb-4"
          label="UTA Phone"
          v-model="userClicked.utaPhone"
          ref="utaPhone"
          :rules="[rules.phone]"
          hint="Used to forward calls to this phone."
          persistent-hint
        ></v-text-field>
        <v-select
          class="mx-3"
          :items="branches"
          hide-details
          multiple
          label="Branch"
          v-model="userClicked.selectedBranches"
        ></v-select>
        <v-checkbox
          v-if="!userClicked.isWindowsUser"
          class="mx-3 mb-2"
          label="Disabled"
          v-model="userClicked.disabled"
          hide-details
          color="success"
        ></v-checkbox>
        <v-card-actions>
          <v-layout column>
            <v-select
              class="mb-5"
              hide-details
              multiple
              label="Role"
              chips
              item-text="name"
              v-model="userClicked.roles"
              :items="roles"
            ></v-select>

            <div class="text-xs-right">
              <v-spacer></v-spacer>
              <v-btn
                color="default"
                dark
                @click="
                  updateUserDialog = false;
                  showResetPasswordSection = false;
                "
                >Cancel</v-btn
              >
              <v-btn
                color="warning"
                dark
                :loading="deletingUser"
                @click="deleteUserConfirmationDialog = true"
                >Delete</v-btn
              >
              <v-btn
                :disabled="deletingUser"
                :loading="processing"
                color="success"
                @click="updateUser"
              >
                save
              </v-btn>
            </div></v-layout
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loginHistoryDialog" max-width="850">
      <v-card class="pa-2 login-history-card">
        <v-card-title class="headline pb-1 pt-2">
          Login History - {{ userClicked.userName }}
        </v-card-title>
        <v-card-text>
          <v-progress-linear
            v-if="loadingLoginHistory"
            indeterminate
            color="success"
            class="mb-3"
          ></v-progress-linear>
          <v-layout row wrap>
            <v-flex xs12 sm4 class="pr-2">
              <v-text-field
                v-model="loginHistoryFilters.startDate"
                label="Start Date"
                type="date"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 class="pr-2">
              <v-text-field
                v-model="loginHistoryFilters.endDate"
                label="End Date"
                type="date"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
                v-model="loginHistoryFilters.clientIP"
                label="Client IP"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-data-table
            :headers="loginHistoryHeaders"
            :items="filteredLoginHistory"
            :loading="loadingLoginHistory"
            :pagination.sync="loginHistoryPagination"
            :custom-sort="sortLoginHistory"
            :rows-per-page-items="[8, 25, 50, 100]"
            class="elevation-1 login-history-table"
            no-data-text="No Login History Found"
          >
            <template v-slot:items="props">
              <tr>
                <td>{{ formatDateTime(props.item.timestamp) }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.clientIP }}</td>
                <td>{{ props.item.username }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="loginHistoryDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    title: "Users",
    columns: [
      {
        sortable: true,
        label: "User Name",
        field: "userName",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Name",
        field: "name",
        hidden: false,
        width: "250px",
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Email",
        field: "email",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Phone",
        field: "phoneNumber",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Roles",
        field: "roleNames",
        width: "300px",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Branch",
        field: "branch",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Windows User",
        field: "isWindowsUser",
        width: "220px",
        type: "boolean",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "UTA Phone",
        field: "utaPhone",
        width: "200px",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Disabled",
        field: "disabled",
        width: "150px",
        type: "boolean",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Last Login",
        field: "lastLogin",
        type: "date",
        dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
        hidden: false,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Created By",
        field: "createdBy",
        width: "200px",
        hidden: true,
        filterOptions: {
          enabled: true,
        },
      },
      {
        sortable: true,
        label: "Created On",
        field: "createdOn",
        type: "date",
        dateOutputFormat: "MM/DD/YYYY",
        hidden: true,
        filterOptions: {
          enabled: true,
        },
      },
    ],
    actions: [
      {
        text: "Add User",
        link: "AddUser",
      },
    ],

    updateUserDialog: false,
    userClicked: {},
    processing: false,
    deletingUser: false,
    deleteUserConfirmationDialog: false,
    branches: [],

    roles: [],

    showResetPasswordSection: false,
    resetPasswordToken: "",
    newPassword: "",
    loginHistoryDialog: false,
    loadingLoginHistory: false,
    loginHistory: [],
    loginHistoryFilters: {
      startDate: "",
      endDate: "",
      clientIP: "",
    },
    loginHistoryPagination: {
      sortBy: "timestamp",
      descending: true,
      rowsPerPage: 8,
    },
    loginHistoryHeaders: [
      {
        text: "Timestamp",
        value: "timestamp",
      },
      {
        text: "Type",
        value: "type",
      },
      {
        text: "Client IP",
        value: "clientIP",
      },
      {
        text: "Username",
        value: "username",
      },
    ],

    rules: {
      required: (value) => !!value || "Required.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !value || pattern.test(value) || "Invalid e-mail.";
      },
      phone: (v) => {
        const digits = (v ? v : "").replace(/\D/g, "");
        return (
          !(v ? v.trim() : v) ||
          digits.length === 10 ||
          (digits.length === 11 && digits.startsWith("1")) ||
          "Use 10 digits or 11 digits starting with 1."
        );
      },
    },
  }),
  created() {
    this.loadRoles();
    this.loadBranchList();

    const importUsersAction = {
      text: "Import Users",
      name: "ImportUsers",
      loading: false,
    };

    importUsersAction.action = () =>
      this.importUsers(importUsersAction.loading);

    this.actions.push(importUsersAction);
  },
  computed: {
    filteredLoginHistory() {
      return this.loginHistory.filter((item) => {
        const clientIPFilter = (this.loginHistoryFilters.clientIP || "")
          .trim()
          .toLowerCase();
        const startDateFilter = (
          this.loginHistoryFilters.startDate || ""
        ).trim();
        const endDateFilter = (this.loginHistoryFilters.endDate || "").trim();

        const matchesClientIP =
          !clientIPFilter ||
          (item.clientIP || "").toLowerCase().includes(clientIPFilter);
        const itemDate = this.getDateFilterValue(item.timestamp);
        const matchesStartDate =
          !startDateFilter || itemDate >= startDateFilter;
        const matchesEndDate = !endDateFilter || itemDate <= endDateFilter;

        return matchesClientIP && matchesStartDate && matchesEndDate;
      });
    },
  },
  methods: {
    normalizePhone(value) {
      const digits = (value ? value : "").replace(/\D/g, "");

      if (!digits) return "";
      if (digits.length === 10) return "1" + digits;
      if (digits.length === 11 && digits.startsWith("1")) return digits;

      return "";
    },
    async loadRoles() {
      const response = await this.$http.get("odata/roles");

      this.roles = response.value.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },
    async onRowClicked(user) {
      this.userClicked = JSON.parse(JSON.stringify(user));
      this.userClicked.name = this.userClicked.name
        ? this.userClicked.name
        : "";
      this.userClicked.phoneNumber = this.userClicked.phoneNumber
        ? this.userClicked.phoneNumber
        : "";
      this.userClicked.utaPhone = this.userClicked.utaPhone
        ? this.userClicked.utaPhone
        : "";

      this.userClicked.roles = await this.$http.get(
        "api/login/GetUserRoles?userName=" + user.userName
      );

      this.userClicked.selectedBranches = this.userClicked.branch
        ? this.userClicked.branch.split(",")
        : [];

      this.showResetPasswordSection = false;
      this.updateUserDialog = true;
    },
    async loadBranchList() {
      const branches = await this.$http.get("api/students/getBranchList?");

      branches.push("BUS");
      branches.push("ALL");

      this.branches = branches.filter(Boolean).sort();
    },
    async resetPassword() {
      // const token = await this.$http.get(
      //     "api/login/getResetToken?userId=" + this.userClicked.id
      // );

      // this.resetPasswordToken = token[0];

      this.newPassword = "";
      this.showResetPasswordSection = true;
    },
    async importUsers() {
      try {
        await this.$http.post("api/login/importAdUsers");

        this.$notify({
          group: "notification",
          text: "Users List Updated",
          type: "success",
        });

        this.$refs.grid.load();
      } catch (e) {}
    },
    formatDateTime(value) {
      if (!value) return "";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;

      return (
        date.toLocaleDateString() +
        " " +
        date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    },
    getDateFilterValue(value) {
      if (!value) return "";

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "";

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    sortLoginHistory(items, index, isDescending) {
      if (!index) return items;

      const sortBy = Array.isArray(index) ? index[0] : index;
      const descending = Array.isArray(isDescending)
        ? isDescending[0]
        : isDescending;

      return items.slice().sort((a, b) => {
        let result = 0;

        if (sortBy === "timestamp") {
          const aDate = new Date(a.timestamp);
          const bDate = new Date(b.timestamp);
          result = aDate - bDate;
        } else {
          const x = (a[sortBy] || "").toString().toLowerCase();
          const y = (b[sortBy] || "").toString().toLowerCase();
          result = x > y ? 1 : x < y ? -1 : 0;
        }

        return descending ? -result : result;
      });
    },
    async openLoginHistory() {
      if (!this.userClicked.userName) return;

      this.loginHistoryDialog = true;
      this.loadingLoginHistory = true;
      this.loginHistoryFilters.startDate = "";
      this.loginHistoryFilters.endDate = "";
      this.loginHistoryFilters.clientIP = "";

      try {
        const history = await this.$http.get(
          "api/users/GetLoginHistory?user=" + this.userClicked.userName
        );
        this.loginHistory = Array.isArray(history) ? history : [];
      } catch (e) {
        this.loginHistory = [];
      } finally {
        this.loadingLoginHistory = false;
      }
    },
    async saveNewPassword() {
      if (!this.$refs.newPassword.validate(true)) return false;

      this.processing = true;

      try {
        await this.$http.post("api/login/resetPassword", {
          userId: this.userClicked.id,
          //token: this.resetPasswordToken,
          newPassword: this.newPassword,
        });

        this.newPassword = "";

        return true;
      } catch (e) {
        this.processing = false;

        return false;
      }
    },
    async deleteUser() {
      this.deletingUser = true;

      try {
        await this.$http.post(
          "api/login/DeleteUser?userId=" + this.userClicked.id
        );

        this.$refs.grid.load();

        this.deleteUserConfirmationDialog = false;
        this.updateUserDialog = false;
      } catch (e) {
      } finally {
        this.deletingUser = false;
      }
    },
    async updateUser() {
      if (this.showResetPasswordSection) {
        const saved = await this.saveNewPassword();

        if (!saved) return;
      }
      if (
        !this.$refs.email.validate(true) ||
        !this.$refs.phoneNumber.validate(true) ||
        !this.$refs.utaPhone.validate(true)
      ) {
        return;
      }

      this.processing = true;

      try {
        const name = this.userClicked.name ? this.userClicked.name.trim() : "";
        const email = this.userClicked.email
          ? this.userClicked.email.trim()
          : "";
        const phoneNumber = this.normalizePhone(this.userClicked.phoneNumber);
        const utaPhone = this.normalizePhone(this.userClicked.utaPhone);

        await this.$http.post("api/login/UpdateUser", {
          username: this.userClicked.userName,
          name,
          branch: this.userClicked.selectedBranches.join(","),
          roles: this.userClicked.roles,
          email,
          phoneNumber,
          utaPhone,
          disabled: this.userClicked.disabled || false,
        });

        this.$refs.grid.load();
        this.updateUserDialog = false;
      } catch (e) {
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>
<style>
.login-history-card {
  max-height: 90vh;
}

.login-history-table .v-table__overflow {
  max-height: 420px;
  overflow-y: auto;
}
</style>
